export const css = {
    root: 'hk785NMo',
    content: 'VxfRYB92',
    title: 'tgEk-UCh',
    subtitle: 'KgsB7Oyk',
    actions: 'VMfaebhe',
    ' _key': 'card/posttest'
};
export default css;
